<template>
	<div>
		<Popup v-model:show="showEmployeePop" :style="{ width:'80%',top:'30%' }">
			<div class="news-page">
				<div style="display: flex;">
					<img :src="employeeInfo.avatar" alt="" style="width: var(--base-px-50);height: var(--base-px-50);">
					<div style="margin-left: var(--base-px-10);margin-top: var(--base-px-5);display: flex;">
						<span style="font-weight: bold;">{{ employeeInfo.employeeName }}</span>
						<img src="../../../assets/personalIcon.png" alt=""
						     style="width: var(--base-px-20);height: var(--base-px-20);margin-left: var(--base-px-5);margin-top: -1px;">
					</div>
				</div>
				<Divider/>
				<div class="news-row">
					<div style="color: #999;">部门</div>
					<div style="padding-left: var(--base-px-15);">{{ employeeInfo.corpName }}</div>
				</div>
				<van-button type="primary" block class="send-btn" @click="sendBtn">发消息</van-button>
			</div>
		</Popup>
	</div>
</template>

<script>
import {Popup, Divider} from 'vant'
// eslint-disable-next-line no-unused-vars
import {openEnterpriseChat} from '@/utils/wxCodeAuth'

export default {
	components: {
		Popup, Divider
	},
	data() {
		return {
			showEmployeePop: false,
			employeeInfo: {}
		}
	},
	methods: {
		show(employeeInfo) {
			this.showEmployeePop = true
			this.employeeInfo = employeeInfo
		},
		// 发送消息
		async sendBtn() {
			const userIds = this.employeeInfo.wxUserId
			await openEnterpriseChat(userIds)
		}
	}
}
</script>
<style scoped lang="less">
.news-page {
	padding: var(--base-px-35) var(--base-px-35) var(--base-px-25) var(--base-px-35);
	font-size: var(--base-px-14);
}

.news-flex {
	display: flex;
	justify-content: space-between;
}

.news-row {
	display: flex;
}

.send-btn {
	margin-top: var(--base-px-30);
	height: var(--base-px-40);
}
</style>
